module.exports = __webpack_public_path__ + "img/notApproved.7d377759.svg";